import axios from 'axios';
import { getToken } from '../storageService/GlobalData';

export const baseUrl = process.env.REACT_APP_API_URL;

export const apiClient = (token) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const defaultOptions = {
    timeout: 180000,
    headers: {
      token: token ? token : getToken(),
      'Content-Type': 'application/json',
      'User-Device': 'mobile',
    },
  };

  return {
    getBaseUrl: () => `${apiUrl}`,
    get: (url, options = {}) => {
      if (!isCompleteUrl(url)) {
        url = `${apiUrl}${url}`;
      }
      return axios.get(`${url}`, { ...defaultOptions, ...options });
    },
    post: (url, data, options = {}) => {
      if (!isCompleteUrl(url)) {
        url = `${apiUrl}${url}`;
      }
      return axios.post(`${url}`, data, { ...defaultOptions, ...options });
    },
    put: (url, data, options = {}) => {
      if (!isCompleteUrl(url)) {
        url = `${apiUrl}${url}`;
      }
      return axios.put(`${url}`, data, { ...defaultOptions, ...options });
    },
    delete: (url, options = {}) => {
      if (!isCompleteUrl(url)) {
        url = `${apiUrl}${url}`;
      }
      return axios.delete(`${url}`, { ...defaultOptions, ...options });
    },
  };
};

function isCompleteUrl(url = '') {
  return url.indexOf('https://') > -1 || url.indexOf('http://') > -1;
}
